<template>
  <div :class="[classes]">
    <div class="overflow-visible rounded-lg shadow-sm">
      <Listbox v-model="selected_item" :disabled="disabled" as="div" class="relative w-full overflow-visible">
        <label
          v-show="showLabel && !noBorder"
          :class="[
            `${isBoxBackground ? 'bg-gray-100 dark:bg-dark-box-background' : 'bg-light-label-background dark:bg-dark-box-background'} ${
              icon ? 'ml-8' : ''
            }`
          ]"
          :for="name"
          class="absolute px-1 h-1 text-sm font-medium transition-all rounded-md left-1 top-0 text-common-grey peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3 dark:text-dark-body-text peer-focus:font-normal peer-focus:text-blue">
          <span class="relative -top-2.5">{{ label }}</span></label>
        <div>
          <ListboxButton
            :class="[
              disabled ? 'text-common-grey' : '',
              inputClasses,
              isBoxBackground
                ? 'bg-light-box-background dark:bg-dark-box-background'
                : 'bg-light-screen-background dark:bg-dark-box-background group/name has-tooltip'
            ]"
            class="w-full min-w-max py-2 font-medium rounded-lg text-light-body-text dark:text-dark-body-text transition ease-in-out border-[1px] border-light-divider-border dark:border-dark-divider-border duration-side-menu-transition-duration pr-8 bg-light-screen-background max-h-[48px]"
            @focusin="focusInput"
            @focusout="unfocusInput">
            <span v-if="icon" class="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
              <component :is="icon" :key="$route.fullPath" class="w-5 h-5 text-gray-400" aria-hidden="true" />
            </span>
            <span v-if="currentItem" class="mx-1 ml-2 text-sm text-light-grey-text dark:text-white" :class="{ 'pl-5': icon }">{{
              getLabel
            }}</span>
            <span
              v-else
              class="block ml-2 mr-5 text-sm font-medium truncate transition ease-in-out opacity-50 text-light-grey-text dark:text-gray-200 dark:bg-dark-box-background duration-side-menu-transition-duration"
              :class="{ 'pl-5': icon }">{{ placeholder }}</span>
            <span class="absolute inset-y-0 flex items-center pointer-events-none right-2">
              <ChevronDown class="w-5 h-5 text-gray-400" aria-hidden="true" />
            </span>
          </ListboxButton>
          <transition leave-active-class="transition duration-100 ease-in" leave-from-class="opacity-100" leave-to-class="opacity-0">
            <ListboxOptions
              v-if="items_clone?.length > 0"
              :class="[
                isBoxBackground
                  ? 'bg-light-box-background dark:bg-dark-box-background'
                  : 'bg-light-screen-background dark:bg-dark-screen-background'
              ]"
              class="absolute z-[60] w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg min-w-max dark:bg-dark-screen-background dark:text-white max-h-56 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              <ListboxOption v-if="currentItem && allowNull" key="reset" v-slot="{ active }" :value="null">
                <li
                  :class="[
                    active
                      ? 'text-dark-body-text bg-light-brand-blue dark:text-light-body-text dark:bg-dark-brand-blue'
                      : 'text-light-body-text dark:text-dark-body-text',
                    'cursor-default relative py-2 pl-8 pr-4 rounded-lg  text-light-body-text dark:text-dark-body-text hover:bg-light-brand-blue dark:hover:bg-dark-brand-blue transition ease-in-out duration-500'
                  ]">
                  <span class="block font-medium text-right truncate opacity-50 hover:text-white hover:opacity-100">
                    {{ translatedClearSelection }}
                  </span>
                </li>
              </ListboxOption>
              <ListboxOption
                v-for="(item, index) in items_clone"
                :key="index"
                v-slot="{ active, selected }"
                as="template"
                :value="valueAttr ? item[valueAttr] : item">
                <li
                  v-if="item.id == 'create_group'"
                  :class="[
                    active
                      ? 'text-dark-body-text bg-light-brand-blue dark:bg-dark-brand-blue'
                      : 'text-light-body-text dark:text-dark-body-text',
                    'relative group/items cursor-default  py-2 pl-8 pr-4 items-center justify-center rounded-lg transition ease-in-out duration-side-menu-transition-duration'
                  ]">
                  <span :class="[selected ? 'font-semibold' : 'font-bold', 'block truncate']">
                    {{ labelAttr ? item[labelAttr] : item }}
                  </span>

                  <span>
                    <Plus
                      :class="[
                        active ? 'opacity-100 text-light-body-text dark:text-dark-body-text' : 'text-common-grey',
                        'opacity-0 group-hover/items:text-white absolute inset-y-0 left-0 flex items-center pl-1.5 transition ease-in-out duration-side-menu-transition-duration'
                      ]"
                      class="h-full w-7 absolute inset-y-0 left-0 flex items-center pl-1.5"
                      aria-hidden="true" />
                  </span>
                </li>
                <li
                  v-else
                  :class="[
                    active
                      ? 'text-dark-body-text bg-light-brand-blue dark:bg-dark-brand-blue'
                      : 'text-light-body-text dark:text-dark-body-text',
                    'relative group/items cursor-default  py-2 pl-8 pr-4 items-center justify-center rounded-lg transition ease-in-out duration-side-menu-transition-duration'
                  ]">
                  <span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">
                    {{ labelAttr ? item[labelAttr] : item }}
                  </span>

                  <span
                    v-if="selected"
                    :class="[active ? 'text-white' : 'text-blue', 'absolute inset-y-0 left-0 flex items-center pl-1.5']">
                    <Check class="w-5 h-5" aria-hidden="true" />
                  </span>
                  <span v-else>
                    <Check
                      :class="[
                        active ? 'opacity-100 text-light-body-text dark:text-dark-body-text' : 'text-common-grey',
                        'opacity-0 group-hover/items:text-white absolute inset-y-0 left-0 flex items-center pl-1.5 transition ease-in-out duration-side-menu-transition-duration'
                      ]"
                      class="h-full w-7 absolute inset-y-0 left-0 flex items-center pl-1.5"
                      aria-hidden="true" />
                  </span>
                </li>
              </ListboxOption>
            </ListboxOptions>
            <ListboxOptions
              v-else
              as="div"
              :class="[
                isBoxBackground
                  ? 'bg-light-box-background dark:bg-dark-box-background'
                  : 'bg-light-screen-background dark:bg-dark-screen-background'
              ]"
              class="absolute z-50 flex items-center justify-center w-full h-10 p-2 py-1 mt-1 overflow-hidden text-base bg-white rounded-md shadow-lg min-w-max dark:bg-dark-screen-background dark:text-white ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              <span class="relative py-2 pr-4 font-medium cursor-default text-light-body-text dark:text-dark-body-text">
                {{ $t("You don't have any") }} {{ placeholder }}
              </span>
            </ListboxOptions>
          </transition>
        </div>
      </Listbox>
    </div>
  </div>
</template>

<script>
import { ChevronDown, Check, Plus } from "lucide-vue-next"
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from "@headlessui/vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    Listbox,
    ListboxLabel,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    ChevronDown,
    Check,
    Plus
  },
  props: {
    icon: null,
    currentItem: null,
    items: {
      type: Array,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    inputClasses: {
      type: String,
      required: false,
      default: ""
    },
    classes: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    labelAttr: {
      default: null,
      type: [null, String]
    },
    // if the valueAttr is null then the selected_item will be the selected object
    valueAttr: {
      default: null,
      type: [null, String]
    },
    disabled: {
      type: Boolean,
      required: false
    },

    placeholder: {
      type: String,
      default: ""
    },
    clearSelection: {
      type: String,
      default: "Clear selection"
    },
    allowNull: {
      type: Boolean,
      default: true
    },
    isBoxBackground: {
      type: Boolean,
      default: false
    },
    objectType: {
      type: String,
      default: ""
    },
    createGroupAction: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:currentItem"],
  data() {
    return {
      items_clone: [],
      selected_item: null,
      inputIsFocused: false
    }
  },
  computed: {
    translatedClearSelection() {
      return this.$t(this.clearSelection)
    },
    getLabel() {
      if (this.labelAttr && this.currentItem) {
        if (this.valueAttr) {
          return this.items_clone.find((x) => x[this.valueAttr] == this.currentItem)[this.labelAttr]
        } else {
          try {
            return this.items_clone.find((x) => x[this.labelAttr] == this.currentItem[this.labelAttr])[this.labelAttr]
          } catch (_) {
            return this.currentItem
          }
        }
      } else {
        return this.currentItem
      }
    }
  },
  watch: {
    items() {
      this.items_clone = this.$utils.clone(this.items)
      if (this.createGroupAction) {
        this.items_clone.push({
          id: "create_group",
          value: "create_group",
          component_reference: "create_group",
          name: this.$t("Create new Group")
        })
      }
    },
    selected_item() {
      if (this.selected_item == "create_group" || this.selected_item?.id == "create_group") {
        this.selected_item = null
        this.$emitter.emit(ALL_EMITTERS.CREATE_NEW_GROUP, this.objectType)
      } else {
        this.$emit("update:currentItem", this.selected_item)
      }
    }
  },
  created() {
    this.items_clone = this.$utils.clone(this.items)
    if (this.createGroupAction) {
      this.items_clone.push({
        id: "create_group",
        value: "create_group",
        component_reference: "create_group",
        name: this.$t("Create new Group")
      })
    }
  },

  mounted() {
    this.selected_item = this.currentItem
    this.inputIsFocused = false
  },
  methods: {
    focusInput() {
      this.inputIsFocused = true
    },
    unfocusInput() {
      this.inputIsFocused = false
    }
  }
}
</script>
